import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, CircularProgress, Checkbox, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField, InputAdornment, AppBar, Toolbar, IconButton, Typography } from '@material-ui/core'
import { change, show, store, update, uploadPhoto, deletePhoto, reorderPhoto, success as changeSuccess } from '../../../store/actions/campaigns.action'
import { changeAlert } from '../../../store/actions/alert.action'
import { Confirm } from '../../components'
import { rootUrl } from '../../../config/App'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'
import { FaTrash, FaSave } from 'react-icons/fa'
import { MdKeyboardBackspace, MdDelete } from 'react-icons/md'
import MaskedInput from 'react-text-mask'
import ArrayMove from 'array-move'
import { changeScreen } from '../../../store/actions/navigation.action'
import { CKEditor } from 'ckeditor4-react'
import { changeNotify } from '../../../store/actions/notify.action'
import { convertUtcToLocal } from "../../../utils/utc-date"
import imageCompression from "browser-image-compression"

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    let mask = [];

    if (props.name === 'date') {
        mask = [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
    }

    if (props.name === 'int') {
        mask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]
        if (other.value) {
            if (other.value.length >= 4) {
                mask = [/[0-9]/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length >= 5) {
                mask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/]
            }
        }
    }

    if (props.name === 'redirect') {
        mask = [/[0-9]/, /\d/]
    }

    if (props.name === 'perc') {
        mask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]
        if (other.value) {
            if (other.value.length >= 3) {
                if(other.value !== '100') {
                    mask = [/[0-9]/, /\d/, '.', /\d/, /\d/]
                }
            }
        }
    }

    if (props.name === 'qtd') {
        mask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
        if (other.value) {
            if (other.value.length >= 4) {
                mask = [/[0-9]/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length >= 5) {
                mask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length > 6) {
                mask = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length > 7) {
                mask = [/[0-9]/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length > 8) {
                mask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/]
            }
        }
    }

    if (props.name === 'money') {
        mask = [/[0-9]/, /\d/, /\d/, /\d/]
        if (other.value) {
            if (other.value.length > 2) {
                mask = [/[0-9]/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length > 4) {
                mask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/]
            }
            if (other.value.length > 5) {
                mask = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/]
            }
        }
    }

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                if(props.name === 'money') {
                    if(ref) {
                        ref.inputElement.value = ref.inputElement.value.includes('.') ? ref.inputElement.value : props.value
                    }
                }
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            guide={false}
        />
    )
}

const SortableItem = SortableElement(({ value }) =>
    <div className="bg-img" style={{ backgroundImage: 'url(' + rootUrl + 'thumb/rifa/' + value.img + '?s=' + value.rifa_id + '&h=250&w=250)' }}></div>
);

const SortableList = SortableContainer(({ children }) => {
    return <div id="conteiner" className="row">{children}</div>
});

export default function ActionsEdit(props) {
    const dispatch = useDispatch()
    const { app } = useSelector(state => state.appReducer)
    const { campaign, error, accounts, status, roulette } = useSelector(state => state.campaignsReducer)
    const id = (props.uid) ? props.uid : null;

    const [isLoading, setLoading] = React.useState(true)

    const [state, setState] = React.useState({
        isDeleted: null,
        confirmEl: null
    })

    const date = new Date();
    const dateInit = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T00:00'
    const dateEnd = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T23:59'

    const [dateInitial, setDateInitial] = React.useState(dateInit)
    const [dateFinal, setDateFinal] = React.useState(dateEnd)

    const [dateInitialB, setDateInitialB] = React.useState(dateInit)
    const [dateFinalB, setDateFinalB] = React.useState(dateEnd)

    const [click, setClick] = React.useState(0)

    const [minValid, setMinValid] = React.useState({
        min: '',
        min2: '',
        min3: '',
        attempt: '',
        attempt2: '',
        attempt3: ''
    })

    React.useEffect(() => {
        _validatePrize(1, true)
    }, [campaign.price, isLoading])


    React.useEffect(() => {
        _index()
        return () => {
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _index = () => {
        if (id) {
            dispatch(show(id)).then(() => setLoading(false))
        } else {
            dispatch(store()).then(() => setLoading(false))
        }
    }

    const handleUpload = async (event) => {
        const files = [...event.target.files];
        
        const options = {
            maxWidthOrHeight: 1200,
            maxSizeMB: 1,
            useWebWorker: true,
            fileType: "image/jpeg"
        };

        for (const img of files) {
            const compressedFile = await imageCompression(img, options);
            const body = new FormData();
            body.append("file", compressedFile);
            body.append("id", campaign.id);

            dispatch(uploadPhoto(body));
        }

        if (error.fotos && delete error.fotos);
    }

    const _deletePhoto = (id) => {
        setState({
            ...state,
            isDeleted: id
        })

        dispatch(deletePhoto(id)).then(res => res && setState({
            ...state,
            isDeleted: null
        }))
    }

    const handleConfirm = event => {
        setState({
            ...state,
            confirmEl: event.currentTarget
        });
    }

    const onSortEnd = ({ oldIndex, newIndex }) => {
        let items = ArrayMove(campaign.fotos, oldIndex, newIndex);
        let order = items.map(({ id }) => id);
        dispatch(reorderPhoto({ order: order }, items));
    }

    const _validatePrize = (qtd, valid = false) => {
        if(qtd > 0) {
            qtd = parseInt(String(qtd).replace(".", ""))
        }

        let price = document.getElementById('price') ? document.getElementById('price').value : null
        
        if(!price) {
            return {
                min: '',
                validate: false,
                attempt: ''
            }
        }
        
        let min = Math.round(1 / price)
        let value = qtd * price
        let attempt = Math.round(value / 1)

        if(attempt < 1) {
            attempt = 1
        }

        if(valid) {
            setMinValid({
                min: String(min),
                min2: String(min * 2),
                min3: String(min * 3),
                attempt: String(attempt),
                attempt2: String(attempt * 2),
                attempt3: String(attempt * 3),
            })
        }

        if(value < 1) {
            return {
                min: min,
                validate: false,
                attempt: attempt < 1 ? 1 : 0
            }
        }

        return {
            min: min,
            validate: true,
            attempt: attempt
        }
    }

    const _text = (text) => {
        if(campaign.instant_prize_type === 'scratch') {
            if(text === 'Qtd. Giros') {
                return 'Qtd. Raspadinha'
            }
        }

        if(campaign.instant_prize_type === 'roulette') {
            return text
        }
    }

    const handleUpdate = () => {
        let data = {
            top_init_at: convertUtcToLocal(campaign.top_init_at),
            top_end_at: convertUtcToLocal(campaign.top_end_at),
            multiple_init_at: convertUtcToLocal(campaign.multiple_init_at),
            multiple_end_at: convertUtcToLocal(campaign.multiple_end_at),
            notice_init_at: convertUtcToLocal(campaign.notice_init_at),
            notice_end_at: convertUtcToLocal(campaign.notice_end_at),
            bigger_title_init_at: convertUtcToLocal(campaign.bigger_title_init_at),
            bigger_title_end_at: convertUtcToLocal(campaign.bigger_title_end_at),
            price: document.getElementById('price') ? document.getElementById('price').value : null,
            price2: document.getElementById('price2') ? document.getElementById('price2').value : null,
            price3: document.getElementById('price3') ? document.getElementById('price3').value : null,
            price4: document.getElementById('price4') ? document.getElementById('price4').value : null,
            prize_qtd: document.getElementById('prize_qtd') ? document.getElementById('prize_qtd').value : null,
            prize_qtd_2: document.getElementById('prize_qtd_2') ? document.getElementById('prize_qtd_2').value : null,
            prize_qtd_3: document.getElementById('prize_qtd_3') ? document.getElementById('prize_qtd_3').value : null,
            prize_attempt: document.getElementById('prize_attempt') ? parseInt(document.getElementById('prize_attempt').value) : null,
            prize_attempt_2: document.getElementById('prize_attempt_2') ? parseInt(document.getElementById('prize_attempt_2').value) : null,
            prize_attempt_3: document.getElementById('prize_attempt_3') ? parseInt(document.getElementById('prize_attempt_3').value) : null,
            minimum_transaction: document.getElementById('minimum_transaction') ? document.getElementById('minimum_transaction').value : null
        }

        setClick(click + 1);
        if(click < 1) {
            dispatch(update({...campaign, ...data})).then(res => res === 'error' && setClick(0));
        }
    }

    return (
        <>
        <AppBar position="fixed">
            <Toolbar>
                <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                    <MdKeyboardBackspace />
                </IconButton>
                <Typography variant="h6">
                    {(id) ? 'Editar Campanha' : 'Nova Campanha'}
                </Typography>

                <Button 
                    variant="contained" 
                    size="small"
                    onClick={() => handleUpdate()} 
                    color="inherit" 
                    className="ms-auto btn-app-bar"
                    startIcon={<FaSave />}
                >
                    Salvar
                </Button>
            </Toolbar>
        </AppBar>

        <div className="mt-5 pt-1 bg-clear min-vh-100">
            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-5">
                            <label className="label-custom bs-color-b">Titulo</label>
                            <TextField
                                error={(error.title) && true}
                                value={campaign.title || ''}
                                placeholder="Ex: Ganhe um iPhone 12 Pro 256 GB"
                                onChange={text => {
                                    dispatch(change({ title: text.target.value }))
                                    if (error.title && delete error.title);
                                }}
                            />

                            {(error.title) &&
                                <strong className="text-danger">{error.title[0]}</strong>
                            }
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">1° Prêmio</label>
                            <TextField
                                error={(error.product) && true}
                                value={campaign.product || ''}
                                placeholder="Ex: iPhone 12 Pro 256 GB"
                                onChange={text => {
                                    dispatch(change({ product: text.target.value }))
                                    if (error.product && delete error.product);
                                }}
                            />

                            {(error.product) &&
                                <strong className="text-danger">{error.product[0]}</strong>
                            }
                        </div>

                        {(campaign.product) &&
                            <div className="mb-3">
                                <label className="label-custom bs-color-b">2° Prêmio</label>
                                <TextField
                                    value={campaign.product2 || ''}
                                    placeholder="Ex: iPhone 12 Pro 256 GB"
                                    onChange={text => dispatch(change({ product2: text.target.value }))}
                                />
                            </div>
                        }

                        {(campaign.product2) &&
                            <div className="mb-3">
                                <label className="label-custom bs-color-b">3° Prêmio</label>
                                <TextField
                                    value={campaign.product3 || ''}
                                    placeholder="Ex: iPhone 12 Pro 256 GB"
                                    onChange={text => dispatch(change({ product3: text.target.value }))}
                                />
                            </div>
                        }

                        {(campaign.product3) &&
                            <div className="mb-3">
                                <label className="label-custom bs-color-b">4° Prêmio</label>
                                <TextField
                                    value={campaign.product4 || ''}
                                    placeholder="Ex: iPhone 12 Pro 256 GB"
                                    onChange={text => dispatch(change({ product4: text.target.value }))}
                                />
                            </div>
                        }

                        {(campaign.product4) &&
                            <div className="mb-3">
                                <label className="label-custom bs-color-b">5° Prêmio</label>
                                <TextField
                                    value={campaign.product5 || ''}
                                    placeholder="Ex: iPhone 12 Pro 256 GB"
                                    onChange={text => dispatch(change({ product5: text.target.value }))}
                                />
                            </div>
                        }

                    </div>

                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Prêmio para quem comprar mais cotas</label>
                            <TextField
                                value={campaign.product_mais || ''}
                                placeholder="Ex: R$ 1.000 reais no pix"
                                onChange={text => dispatch(change({ product_mais: text.target.value }))}
                            />
                        </div>
                    </div>

                    <div className="card card-body card-border mt-3 bs-bg">

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Data de lançamento da Campanha</label>
                            <div className="date">
                                <label className={"label-date "+(campaign.init ? 'text-muted' : 'bs-color-b')}>
                                    {(campaign.launch_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(campaign.launch_at))}&nbsp;&nbsp;&nbsp;
                                    {(campaign.launch_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.launch_at))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    disabled={(campaign.init) && true}
                                    type="datetime-local"
                                    defaultValue={campaign.launch_at}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onBlur={e => {
                                        if(e.target.value) {
                                            dispatch(change({ launch_at: e.target.value }))
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <>
                                            {!campaign.init &&
                                                <InputAdornment className="pointer bs-color" position="end" onClick={() => dispatch(change({ launch_at: null }))}>
                                                    <MdDelete color="#444" size={25} />
                                                </InputAdornment>
                                            }
                                            </>
                                        )
                                    }}
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Horário de encerramento das Vendas</label>
                            <div className="date">
                                <label className={"label-date "+(campaign.init ? 'text-muted' : 'bs-color-b')}>
                                    {(campaign.close_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(campaign.close_at))}&nbsp;&nbsp;&nbsp;
                                    {(campaign.close_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.close_at))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    type="datetime-local"
                                    defaultValue={campaign.close_at}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onBlur={e => {
                                        if(e.target.value) {
                                            dispatch(change({ close_at: e.target.value }))
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment className="pointer bs-color" position="end" onClick={() => dispatch(change({ close_at: null }))}>
                                                <MdDelete color="#444" size={25} />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Data Prevista para o sorteio</label>
                            <div className="date">
                                <label className="label-date bs-color-b">
                                    {(campaign.prev_sorteio) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(campaign.prev_sorteio))}&nbsp;&nbsp;&nbsp;
                                    {(campaign.prev_sorteio) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.prev_sorteio))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    type="datetime-local"
                                    defaultValue={campaign.prev_sorteio}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onBlur={e => {
                                        if(e.target.value) {
                                            dispatch(change({ prev_sorteio: e.target.value }))
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end" onClick={() => dispatch(change({ prev_sorteio: null }))}>
                                                <MdDelete color="#444" size={25} />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade de numeros</label>
                                    <TextField
                                        error={(error.numbers) && true}
                                        disabled={(id) && true}
                                        name="qtd"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: (id) ? undefined : TextMaskCustom,
                                            value: (id) ? campaign.total.toLocaleString('pt-BR', {style: 'decimal'}) : campaign.numbers,
                                            placeholder: '10.000.000',
                                            onChange: text => {
                                                if(parseInt(text.target.value.replace('.', '')) > 1000000) {
                                                    if(parseInt(text.target.value.replace('.', '')) !== 10000000) {
                                                        dispatch(changeAlert({
                                                            open: true,
                                                            msg: 'Ações acima de 1M somente de 10M ',
                                                            class: 'error'
                                                        }))

                                                        dispatch(change({ numbers: null }))
                                                    }
                                                } else {
                                                    dispatch(change({ numbers: text.target.value }))
                                                }
                                                
                                                if (error.numbers && delete error.numbers);
                                            }
                                        }}
                                    />
                                    {(error.numbers) &&
                                        <strong className="text-danger">{error.numbers[0]}</strong>
                                    }
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">PREÇO</label>
                                    <TextField
                                        id="price"
                                        error={(error.price) && true}
                                        name="money"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.price || '',
                                            onChange: text => {
                                                dispatch(change({ price: text.target.value.replace(',', '.') }))
                                                if (error.price) {
                                                    delete error.price
                                                }
                                            },
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>R$</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />

                                    {(error.price) &&
                                        <strong className="text-danger">{error.price[0]}</strong>
                                    }
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Valor mínimo por compra</label>
                                    <TextField
                                        id="minimum_transaction"
                                        name="money"
                                        type="tel"
                                        error={(error.minimum_transaction) && true}
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.minimum_transaction || '',
                                            onChange: text => {
                                                dispatch(change({ minimum_transaction: text.target.value }))
                                                
                                                if (error.minimum_transaction) {
                                                    delete error.minimum_transaction
                                                }

                                                if (text.target.value < 1 && text.target.value !== '') {
                                                    dispatch(changeAlert({
                                                        open: true,
                                                        msg: 'Limite mínimo de R$ 1.00 por compra',
                                                        class: 'error'
                                                    }))

                                                    dispatch(change({ minimum_transaction: 1 }))
                                                }
                                            },
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>R$</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />

                                    {(error.minimum_transaction) &&
                                        <strong className="text-danger">{error.minimum_transaction[0]}</strong>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Descrição</label>
                            <CKEditor
                                initData={campaign.description}
                                config={{
                                    toolbar: [
                                        ['Bold', 'Italic'],
                                        ['Format']
                                    ]
                                }}
                                onChange={ event => {
                                    dispatch(change({ description: event.editor.getData() }))
                                    if(error.description && delete error.description);
                                }}
                            />

                            {(error.description) &&
                                <strong className="text-danger">{error.description[0]}</strong>
                            }
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Status de Exibição</h3>

                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-3">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Status</FormLabel>
                                <RadioGroup 
                                    aria-label="status_detail" 
                                    name="status_detail" 
                                    value={campaign.status_detail} 
                                    onChange={ e => dispatch(change({ status_detail: parseInt(e.target.value) }))}
                                    className="fw-normal bs-color-b"
                                >
                                    {status.map((item, index) => (
                                        <FormControlLabel key={index} value={item.id} control={<Radio color="primary" />} label={item.title} />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Status</label>
                            <TextField
                                value={campaign.status_text}
                                placeholder="Ex: Resultado Hoje"
                                onChange={text => dispatch(change({ status_text: text.target.value })) }
                            />
                        </div>
                        
                        <div className="mb-3">
                            <FormControlLabel
                                className="bs-color-b"
                                control={
                                <Checkbox
                                    checked={(campaign.emphasis === 'false' || campaign.emphasis === false || campaign.emphasis === null ) ? false : true}
                                    onChange={event => dispatch(change({ emphasis: event.target.checked }))}
                                    color="primary"
                                />
                                }
                                label={<strong>DEIXAR COMO DESTAQUE</strong>}
                            />
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Banco</h3>

                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-3">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Banco</FormLabel>
                                <RadioGroup 
                                    aria-label="account_id" 
                                    name="account_id" 
                                    value={campaign.account_id || app.account_id} 
                                    onChange={ e => dispatch(change({ account_id: parseInt(e.target.value) }))}
                                    className="fw-normal bs-color-b"
                                >
                                    {accounts.map((item, index) => (
                                        <FormControlLabel key={index} value={item.id} control={<Radio color="primary" />} label={item.title} />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Aviso Promocional</h3>
                                                    
                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-3">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Ativar ou Desativar</FormLabel>
                                <RadioGroup
                                    aria-label="notice_active" 
                                    name="notice_active"
                                    className="fw-normal bs-color-b"
                                    value={campaign.notice_active ? campaign.notice_active : 0} 
                                    onChange={ e => dispatch(change({ notice_active: parseInt(e.target.value) }))}
                                >
                                    <FormControlLabel value={0} control={<Radio color="primary" />} label="Desativada" />
                                    <FormControlLabel value={1} control={<Radio color="primary" />} label="Ativa" />
                                </RadioGroup>
                            </FormControl>
                        </div>

                        {campaign.notice_active === 1 &&
                            <>
                            <div className="mb-3">
                                <label className="label-custom bs-color-b">Titulo</label>
                                <TextField
                                    value={campaign.notice_title || ''}
                                    placeholder="Ex: 🔥 Chance em dobro! 🔥"
                                    onChange={text => {
                                        if(text.target.value.length < 51) {
                                            dispatch(change({ notice_title: text.target.value }))
                                        }else {
                                            dispatch(changeAlert({
                                                open: true,
                                                msg: 'Máximo 50 caracteres',
                                                class: 'error'
                                            }))
                                        }
                                    }}
                                />
                            </div>

                            <div className="mb-4">
                                <label className="label-custom bs-color-b">Descrição</label>
                                <TextField
                                    value={campaign.notice_description || ''}
                                    placeholder="Ex: Compre agora e ganhe o dobro!"
                                    onChange={text => {
                                        if(text.target.value.length < 36) {
                                            dispatch(change({ notice_description: text.target.value }))
                                        }else {
                                            dispatch(changeAlert({
                                                open: true,
                                                msg: 'Máximo 35 caracteres',
                                                class: 'error'
                                            }))
                                        }
                                    }}
                                />
                            </div>
                                    
                            <div className="row mb-3 mt-2">
                                <div className="col-6 col-lg-6">
                                    <div className="date">
                                        <label className="label-date bs-color-b">
                                            {(campaign.notice_init_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(campaign.notice_init_at))}&nbsp;&nbsp;&nbsp;
                                            {(campaign.notice_init_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.notice_init_at))}    
                                        </label>
                                        <TextField
                                            label="Data Inicial"
                                            type="datetime-local"
                                            defaultValue={campaign.notice_init_at ? convertUtcToLocal(campaign.notice_init_at) : dateInitial}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onBlur={e => {
                                                if(e.target.value) {
                                                    dispatch(change({ notice_init_at: e.target.value }))
                                                } else {
                                                    setDateInitial(dateInitial)
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-6 col-lg-6">
                                    <div className="date">
                                        <label className="label-date bs-color-b">
                                            {(campaign.notice_end_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(campaign.notice_end_at))}&nbsp;&nbsp;&nbsp;
                                            {(campaign.notice_end_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.notice_end_at))}    
                                        </label>
                                        <TextField
                                            label="Data Final"
                                            type="datetime-local"
                                            defaultValue={campaign.notice_end_at ? convertUtcToLocal(campaign.notice_end_at) : dateFinal}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onBlur={e => {
                                                if(e.target.value) {
                                                    dispatch(change({ notice_end_at: e.target.value }))
                                                } else {
                                                    setDateFinal(dateFinal)
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            </>
                        }
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Cota em Dobro</h3>
                                
                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-3">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Ativar ou Desativar</FormLabel>
                                <RadioGroup
                                    aria-label="multiple_active" 
                                    name="multiple_active"
                                    className="fw-normal bs-color-b"
                                    value={campaign.multiple_active ? campaign.multiple_active : 0} 
                                    onChange={ e => dispatch(change({ multiple_active: parseInt(e.target.value) }))}
                                >
                                    <FormControlLabel value={0} control={<Radio color="primary" />} label="Desativada" />
                                    <FormControlLabel value={1} control={<Radio color="primary" />} label="Ativa" />
                                </RadioGroup>
                            </FormControl>
                        </div>

                        {campaign.multiple_active === 1 &&
                            <>
                            <div className="mb-3">
                                <label className="label-custom bs-color-b">Titulo</label>
                                <TextField
                                    value={campaign.multiple_title || ''}
                                    placeholder="Ex: 🔥 Chance em dobro! 🔥"
                                    onChange={text => {
                                        if(text.target.value.length < 31) {
                                            dispatch(change({ multiple_title: text.target.value }))
                                        }else {
                                            dispatch(changeAlert({
                                                open: true,
                                                msg: 'Máximo 30 caracteres',
                                                class: 'error'
                                            }))
                                        }
                                    }}
                                />
                            </div>

                            <div className="mb-4">
                                <label className="label-custom bs-color-b">Descrição</label>
                                <TextField
                                    value={campaign.multiple_description || ''}
                                    placeholder="Ex: Compre agora e ganhe o dobro!"
                                    onChange={text => {
                                        if(text.target.value.length < 36) {
                                            dispatch(change({ multiple_description: text.target.value }))
                                        }else {
                                            dispatch(changeAlert({
                                                open: true,
                                                msg: 'Máximo 35 caracteres',
                                                class: 'error'
                                            }))
                                        }
                                    }}
                                />
                            </div>

                            <div className="row mb-3 mt-2">
                                <div className="col-6 col-lg-6">
                                    <div className="date">
                                        <label className="label-date bs-color-b">
                                            {(campaign.multiple_init_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(campaign.multiple_init_at))}&nbsp;&nbsp;&nbsp;
                                            {(campaign.multiple_init_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.multiple_init_at))}    
                                        </label>
                                        <TextField
                                            id="datetime-local"
                                            label="Data Inicial"
                                            type="datetime-local"
                                            defaultValue={campaign.multiple_init_at ? convertUtcToLocal(campaign.multiple_init_at) : dateInitial}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onBlur={e => {
                                                if(e.target.value) {
                                                    dispatch(change({ multiple_init_at: e.target.value }))
                                                } else {
                                                    setDateInitial(dateInitial)
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-6 col-lg-6">
                                    <div className="date">
                                        <label className="label-date bs-color-b">
                                            {(campaign.multiple_end_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(campaign.multiple_end_at))}&nbsp;&nbsp;&nbsp;
                                            {(campaign.multiple_end_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.multiple_end_at))}    
                                        </label>
                                        <TextField
                                            id="datetime-local"
                                            label="Data Final"
                                            type="datetime-local"
                                            defaultValue={campaign.multiple_end_at ? convertUtcToLocal(campaign.multiple_end_at) : dateFinal}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onBlur={e => {
                                                if(e.target.value) {
                                                    dispatch(change({ multiple_end_at: e.target.value }))
                                                } else {
                                                    setDateFinal(dateFinal)
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            </>
                        }
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Promoção</h3>

                    <div className="card card-body card-border bs-bg">
                        <div className="row">
                            <div className="col-4 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.qtd1 || '',
                                            placeholder: '3',
                                            onChange: text => dispatch(change({ qtd1: text.target.value }))
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-8 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">PREÇO</label>
                                    <TextField
                                        id="price2"
                                        name="money"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.price2 || '',
                                            onChange: text => dispatch(change({ price2: text.target.value.replace(',', '.') })),
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>R$</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-4 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.qtd2 || '',
                                            placeholder: '5',
                                            onChange: text => dispatch(change({ qtd2: text.target.value }))
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-8 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">PREÇO</label>
                                    <TextField
                                        id="price3"
                                        name="money"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.price3 || '',
                                            onChange: text => dispatch(change({ price3: text.target.value.replace(',', '.') })),
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>R$</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-4 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.qtd3 || '',
                                            placeholder: '7',
                                            onChange: text => dispatch(change({ qtd3: text.target.value }))
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-8 col-md-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">PREÇO</label>
                                    <TextField
                                        id="price4"
                                        name="money"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.price4 || '',
                                            onChange: text => dispatch(change({ price4: text.target.value.replace(',', '.') })),
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>R$</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {!roulette &&
                    <>
                    <h3 className="font-weight-normal m-3 bs-color-b">Prêmios Instantâneos</h3>
                    
                    <div className="card card-body card-border bs-bg">
                        <div className="mb-5">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Tipo</FormLabel>
                                <RadioGroup 
                                    aria-label="instant_prize_type" 
                                    name="instant_prize_type" 
                                    value={campaign.instant_prize_type} 
                                    onChange={ e => dispatch(change({ instant_prize_type: e.target.value }))}
                                    className="fw-normal bs-color-b"
                                >
                                    <FormControlLabel value="roulette" control={<Radio color="primary" />} label="Roleta" />
                                    <FormControlLabel value="scratch" control={<Radio color="primary" />} label="Raspadinha" />
                                    <FormControlLabel disabled value="box" control={<Radio color="primary" />} label="Caixinha - (Em breve)" />
                                </RadioGroup>
                            </FormControl>
                        </div>
                        
                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Qtd. Titulos</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        id="prize_qtd"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.prize_qtd || minValid.min,
                                            placeholder: minValid.min,
                                            onChange: text => {
                                                if(text.target.value < 1) {
                                                    dispatch(change({ prize_attempt: '' }))
                                                }
                                                dispatch(change({ prize_qtd: text.target.value }))

                                                setMinValid({
                                                    ...minValid,
                                                    min: text.target.value
                                                })
                                            },
                                            onBlur: () => {
                                                if(parseInt(campaign.prize_qtd) > 0) {
                                                    let valid = _validatePrize(campaign.prize_qtd)

                                                    if(valid.validate === false) {
                                                        dispatch(change({ prize_qtd: valid.min }))
                                                    }
                                                    if(valid.attempt < 1) {
                                                        dispatch(change({ prize_attempt: '' }))
                                                    }else {
                                                        if(campaign.prize_attempt > valid.attempt) {
                                                            dispatch(change({ prize_attempt: valid.attempt }))
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">{_text('Qtd. Giros')}</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        id="prize_attempt"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.prize_attempt || minValid.attempt,
                                            placeholder: minValid.attempt,
                                            onChange: e => {
                                                if(parseInt(campaign.prize_qtd) > 0) {
                                                    let valid = _validatePrize(campaign.prize_qtd)

                                                    setMinValid({
                                                        ...minValid,
                                                        attempt: e.target.value
                                                    })

                                                    if(e.target.value <= valid.attempt) {
                                                        dispatch(change({ prize_attempt: e.target.value }))
                                                    }else {
                                                        dispatch(changeNotify({
                                                            open: true,
                                                            msg: 'Limite máximo de '+valid.attempt+ ' giros',
                                                            class: 'error'
                                                        }))

                                                        dispatch(change({ prize_attempt: valid.attempt }))
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Qtd. Titulos</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        id="prize_qtd_2"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.prize_qtd_2 || minValid.min2,
                                            placeholder: minValid.min2,
                                            onChange: text => {
                                                if(text.target.value < 1) {
                                                    dispatch(change({ prize_attempt_2: '' }))
                                                }
                                                dispatch(change({ prize_qtd_2: text.target.value }))

                                                setMinValid({
                                                    ...minValid,
                                                    min2: text.target.value
                                                })
                                            },
                                            onBlur: () => {
                                                if(parseInt(campaign.prize_qtd_2) > 0) {
                                                    let valid = _validatePrize(campaign.prize_qtd_2)

                                                    if(valid.validate === false) {
                                                        dispatch(change({ prize_qtd_2: valid.min }))
                                                    }
                                                    if(valid.attempt < 1) {
                                                        dispatch(change({ prize_attempt_2: '' }))
                                                    }else {
                                                        if(campaign.prize_attempt_2 > valid.attempt) {
                                                            dispatch(change({ prize_attempt_2: valid.attempt }))
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">{_text('Qtd. Giros')}</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        id="prize_attempt_2"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.prize_attempt_2 || minValid.attempt2,
                                            placeholder: minValid.attempt2,
                                            onChange: e => {
                                                if(parseInt(campaign.prize_qtd_2) > 0) {
                                                    let valid = _validatePrize(campaign.prize_qtd_2)

                                                    setMinValid({
                                                        ...minValid,
                                                        attempt2: e.target.value
                                                    })

                                                    if(e.target.value <= valid.attempt) {
                                                        dispatch(change({ prize_attempt_2: e.target.value }))
                                                    }else {
                                                        dispatch(changeNotify({
                                                            open: true,
                                                            msg: 'Limite máximo de '+valid.attempt+ ' giros',
                                                            class: 'error'
                                                        }))

                                                        dispatch(change({ prize_attempt_2: valid.attempt }))
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Qtd. Titulos</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        id="prize_qtd_3"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.prize_qtd_3 || minValid.min3,
                                            placeholder: minValid.min3,
                                            onChange: text => {
                                                if(text.target.value < 1) {
                                                    dispatch(change({ prize_attempt_3: '' }))
                                                }
                                                dispatch(change({ prize_qtd_3: text.target.value }))

                                                setMinValid({
                                                    ...minValid,
                                                    min3: text.target.value
                                                })
                                            },
                                            onBlur: () => {
                                                if(parseInt(campaign.prize_qtd_3) > 0) {
                                                    let valid = _validatePrize(campaign.prize_qtd_3)

                                                    if(valid.validate === false) {
                                                        dispatch(change({ prize_qtd_3: valid.min }))
                                                    }
                                                    if(valid.attempt < 1) {
                                                        dispatch(change({ prize_attempt_3: '' }))
                                                    }else {
                                                        if(campaign.prize_attempt_3 > valid.attempt) {
                                                            dispatch(change({ prize_attempt_3: valid.attempt }))
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">{_text('Qtd. Giros')}</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        id="prize_attempt_3"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.prize_attempt_3 || minValid.attempt3,
                                            placeholder: minValid.attempt3,
                                            onChange: e => {
                                                if(parseInt(campaign.prize_qtd_3) > 0) {
                                                    let valid = _validatePrize(campaign.prize_qtd_3)

                                                    setMinValid({
                                                        ...minValid,
                                                        attempt3: e.target.value
                                                    })

                                                    if(e.target.value <= valid.attempt) {
                                                        dispatch(change({ prize_attempt_3: e.target.value }))
                                                    }else {
                                                        dispatch(changeNotify({
                                                            open: true,
                                                            msg: 'Limite máximo de '+valid.attempt+ ' giros',
                                                            class: 'error'
                                                        }))

                                                        dispatch(change({ prize_attempt_3: valid.attempt }))
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    </>
                    }

                    <h3 className="font-weight-normal m-3 bs-color-b">Quantidade Sugerida de Compra</h3>

                    <div className="card card-body bs-bg">
                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.quantity_suggested_1,
                                            placeholder: '200',
                                            onChange: text => dispatch(change({ quantity_suggested_1: text.target.value })),
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>+</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                <label className="label-custom bs-color-b"><span className="badge bg-success text-uppercase">Recomendada</span></label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.quantity_suggested_2,
                                            placeholder: '300',
                                            onChange: text => dispatch(change({ quantity_suggested_2: text.target.value })),
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>+</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.quantity_suggested_3,
                                            placeholder: '500',
                                            onChange: text => dispatch(change({ quantity_suggested_3: text.target.value })),
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>+</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.quantity_suggested_4,
                                            placeholder: '1.000',
                                            onChange: text => dispatch(change({ quantity_suggested_4: text.target.value })),
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>+</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.quantity_suggested_5,
                                            placeholder: '5.000',
                                            onChange: text => dispatch(change({ quantity_suggested_5: text.target.value })),
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>+</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="label-custom bs-color-b">Quantidade</label>
                                    <TextField
                                        name="int"
                                        type="tel"
                                        InputProps={{
                                            inputComponent: TextMaskCustom,
                                            value: campaign.quantity_suggested_6,
                                            placeholder: '10.000',
                                            onChange: text => dispatch(change({ quantity_suggested_6: text.target.value })),
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <strong>+</strong>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Top Comprador</h3>

                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-3">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Exibir na Página da Campanha</FormLabel>
                                <RadioGroup
                                    row
                                    aria-label="top_status" 
                                    name="top_status"
                                    className="fw-normal bs-color-b"
                                    value={campaign.top_status} 
                                    onChange={ e => dispatch(change({ top_status: parseInt(e.target.value) }))}
                                >
                                    <FormControlLabel value={1} control={<Radio color="primary" />} label="Não exibir" />
                                    <FormControlLabel value={2} control={<Radio color="primary" />} label="Exibir" />
                                </RadioGroup>
                            </FormControl>
                        </div>

                        {campaign.top_status === 2 &&
                            <>
                            <div className="mb-3">
                                <FormControl component="fieldset">
                                    <FormLabel className="bs-color" component="legend">Quantidade</FormLabel>
                                    <RadioGroup
                                        row
                                        aria-label="top_daily" 
                                        name="top_daily"
                                        className="fw-normal bs-color-b"
                                        value={campaign.top_qtd_users} 
                                        onChange={ e => dispatch(change({ top_qtd_users: parseInt(e.target.value) }))}
                                    >
                                        <FormControlLabel value={3} control={<Radio color="primary" />} label="TOP 3" />
                                        <FormControlLabel value={5} control={<Radio color="primary" />} label="TOP 5" />
                                        <FormControlLabel value={10} control={<Radio color="primary" />} label="TOP 10" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            <div className="mb-3">
                                <FormControl component="fieldset">
                                    <FormLabel className="bs-color" component="legend">Diário ou Personalizado</FormLabel>
                                    <RadioGroup
                                        row
                                        aria-label="top_daily" 
                                        name="top_daily"
                                        className="fw-normal bs-color-b"
                                        value={campaign.top_daily ? campaign.top_daily : 0} 
                                        onChange={ e => dispatch(change({ top_daily: parseInt(e.target.value) }))}
                                    >
                                        <FormControlLabel value={1} control={<Radio color="primary" />} label="Diário" />
                                        <FormControlLabel value={2} control={<Radio color="primary" />} label="Personalizado" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            {campaign.top_daily === 2 &&
                                <div className="row mb-3 mt-2">
                                    <div className="col-6 col-lg-6">
                                        <div className="date">
                                            <label className="label-date bs-color-b">
                                                {(campaign.top_init_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(campaign.top_init_at))}&nbsp;&nbsp;&nbsp;
                                                {(campaign.top_init_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.top_init_at))}    
                                            </label>
                                            <TextField
                                                id="datetime-local"
                                                label="Data Inicial"
                                                type="datetime-local"
                                                defaultValue={campaign.top_init_at ? convertUtcToLocal(campaign.top_init_at) : dateInitial}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onBlur={e => {
                                                    if(e.target.value) {
                                                        dispatch(change({ top_init_at: e.target.value }))
                                                    } else {
                                                        setDateInitial(dateInitial)
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-6 col-lg-6">
                                        <div className="date">
                                            <label className="label-date bs-color-b">
                                                {(campaign.top_end_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(campaign.top_end_at))}&nbsp;&nbsp;&nbsp;
                                                {(campaign.top_end_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.top_end_at))}    
                                            </label>
                                            <TextField
                                                id="datetime-local"
                                                label="Data Final"
                                                type="datetime-local"
                                                defaultValue={campaign.top_end_at ? convertUtcToLocal(campaign.top_end_at) : dateFinal}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onBlur={e => {
                                                    if(e.target.value) {
                                                        dispatch(change({ top_end_at: e.target.value }))
                                                    } else {
                                                        setDateFinal(dateFinal)
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            </>
                        }
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Menor e Maior Cota</h3>
                        <div className="card card-body card-border mt-3 bs-bg">
                            <div className="mb-3">
                                <FormControl component="fieldset">
                                    <FormLabel className="bs-color" component="legend">Exibir na Página da Campanha</FormLabel>
                                    <RadioGroup
                                        row
                                        aria-label="bigger_title_status" 
                                        name="bigger_title_status"
                                        className="fw-normal bs-color-b"
                                        value={campaign.bigger_title_status} 
                                        onChange={ e => dispatch(change({ bigger_title_status: parseInt(e.target.value) }))}
                                    >
                                        <FormControlLabel value={1} control={<Radio color="primary" />} label="Não exibir" />
                                        <FormControlLabel value={2} control={<Radio color="primary" />} label="Exibir" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            {campaign.bigger_title_status === 2 &&
                                <>
                                <div className="mb-3">
                                    <FormControl component="fieldset">
                                        <FormLabel className="bs-color" component="legend">Diário ou Personalizado</FormLabel>
                                        <RadioGroup
                                            row
                                            aria-label="bigger_title_daily" 
                                            name="bigger_title_daily"
                                            className="fw-normal bs-color-b"
                                            value={campaign.bigger_title_daily ? campaign.bigger_title_daily : 0} 
                                            onChange={ e => dispatch(change({ bigger_title_daily: parseInt(e.target.value) }))}
                                        >
                                            <FormControlLabel value={1} control={<Radio color="primary" />} label="Diário" />
                                            <FormControlLabel value={2} control={<Radio color="primary" />} label="Personalizado" />
                                        </RadioGroup>
                                    </FormControl>
                                    
                                </div>

                                {campaign.bigger_title_daily === 2 &&
                                    <div className="row mb-3 mt-2">
                                        <div className="col-6 col-lg-6">
                                            <div className="date">
                                                <label className="label-date bs-color-b">
                                                    {(campaign.bigger_title_init_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(campaign.bigger_title_init_at))}&nbsp;&nbsp;&nbsp;
                                                    {(campaign.bigger_title_init_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.bigger_title_init_at))}    
                                                </label>
                                                <TextField
                                                    id="datetime-local"
                                                    label="Data Inicial"
                                                    type="datetime-local"
                                                    defaultValue={campaign.bigger_title_init_at ? convertUtcToLocal(campaign.bigger_title_init_at) : dateInitialB}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    onBlur={e => {
                                                        if(e.target.value) {
                                                            dispatch(change({ bigger_title_init_at: e.target.value }))
                                                        } else {
                                                            setDateInitialB(dateInitialB)
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6 col-lg-6">
                                            <div className="date">
                                                <label className="label-date bs-color-b">
                                                    {(campaign.bigger_title_end_at) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(campaign.bigger_title_end_at))}&nbsp;&nbsp;&nbsp;
                                                    {(campaign.bigger_title_end_at) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.bigger_title_end_at))}    
                                                </label>
                                                <TextField
                                                    id="datetime-local"
                                                    label="Data Final"
                                                    type="datetime-local"
                                                    defaultValue={campaign.bigger_title_end_at ? convertUtcToLocal(campaign.bigger_title_end_at) : dateFinalB}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    onBlur={e => {
                                                        if(e.target.value) {
                                                            dispatch(change({ bigger_title_end_at: e.target.value }))
                                                        } else {
                                                            setDateFinalB(dateFinalB)
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }
                                </>
                            }
                        </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Midias Sociais</h3>

                    <div className="card card-body card-border mt-3 bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Whatsapp</label>
                            <TextField
                                value={campaign.whatsapp || ''}
                                placeholder="Ex: https://wa.me/5599999999999"
                                onChange={text => {
                                    dispatch(change({ whatsapp: text.target.value }))
                                }}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Instagram</label>
                            <TextField
                                value={campaign.instagram || ''}
                                placeholder="Ex: https://www.instagram.com/seuinstagram"
                                onChange={text => {
                                    dispatch(change({ instagram: text.target.value }))
                                }}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Telegram</label>
                            <TextField
                                value={campaign.telegram || ''}
                                placeholder="Ex: https://t.me/seugrupotelegram"
                                onChange={text => {
                                    dispatch(change({ telegram: text.target.value }))
                                }}
                            />
                        </div>

                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Reservas</h3>

                    <div className="card card-body bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Limite de cotas reservadas por cliente</label>
                            <TextField
                                name="int"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: campaign.max_reserva,
                                    placeholder: '2000',
                                    onChange: text => {
                                        if(parseInt(text.target.value.replace('.', '')) > 50000) {
                                            dispatch(changeAlert({
                                                open: true,
                                                msg: 'Limite máximo de 50.000 cotas por transação',
                                                class: 'error'
                                            }))
                                            dispatch(change({ max_reserva: '50.000' }))
                                        } else {
                                            dispatch(change({ max_reserva: text.target.value }))
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Marketing</h3>

                    <div className="card card-body bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Porcentagem</label>
                            <TextField
                                name="perc"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: campaign.percent_status,
                                    placeholder: '30',
                                    onChange: text => dispatch(change({ percent_status: text.target.value }))
                                }}
                            />
                        </div>

                        <div className="mb-3">
                            <FormControlLabel
                                className="bs-color-b"
                                control={
                                <Checkbox
                                    checked={(campaign.percent_view === 'false' || campaign.percent_view === false || campaign.percent_view === null ) ? false : true}
                                    onChange={event => dispatch(change({ percent_view: event.target.checked }))}
                                    color="primary"
                                />
                                }
                                label={<strong>EXIBIR NO SITE</strong>}
                            />
                        </div>

                        <div className="mb-3">
                            <FormControlLabel
                                className="bs-color-b"
                                control={
                                <Checkbox
                                    checked={(campaign.percent_auto === 'false' || campaign.percent_auto === false || campaign.percent_auto === null ) ? false : true}
                                    onChange={event => dispatch(change({ percent_auto: event.target.checked }))}
                                    color="primary"
                                />
                                }
                                label={<strong>PORCENTAGEM AUTOMÁTICA</strong>}
                            />
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Gatilho pós Compra</h3>

                    <div className="card card-body bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Titulo</label>
                            <TextField
                                value={campaign.trigger_title || ''}
                                placeholder="Ex: VOCÊ GANHOU !"
                                onChange={text => dispatch(change({ trigger_title: text.target.value }))}
                            />
                        </div>
                        
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Descrição</label>
                            <CKEditor
                                initData={campaign.trigger_description}
                                config={{
                                    height: 100,
                                    toolbar: [
                                        ['Bold', 'Italic'],
                                        ['Format']
                                    ]
                                }}
                                onChange={ event => dispatch(change({ trigger_description: event.editor.getData() }))}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Botão</label>
                            <TextField
                                value={campaign.trigger_button || ''}
                                placeholder="Ex: BOTÃO DA VIRADA DE CHAVE !"
                                onChange={text => dispatch(change({ trigger_button: text.target.value }))}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Link</label>
                            <TextField
                                value={campaign.trigger_link || ''}
                                placeholder="https://seulinkexterno.com"
                                onChange={text => dispatch(change({ trigger_link: text.target.value }))}
                            />
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Redirect pós Compra</h3>
                                
                    <div className="card card-body bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Redirecionar Após</label>
                            <TextField
                                name="redirect"
                                placeholder="Ex: 5 segundos"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: campaign.trigger_redirect_time || '',
                                    onChange: text => dispatch(change({ trigger_redirect_time: text.target.value }))
                                }}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Link</label>
                            <TextField
                                value={campaign.trigger_redirect_link || ''}
                                placeholder="https://seulinkexterno.com"
                                onChange={text => dispatch(change({ trigger_redirect_link: text.target.value }))}
                            />
                        </div>
                    </div>

                    <h3 className="font-weight-normal m-3 bs-color-b">Fotos do premio</h3>

                    <div className="card card-body bs-bg">
                        {(error.fotos) &&
                            <strong className="text-danger">{error.fotos[0]}</strong>
                        }

                        <SortableList axis="xy" onSortEnd={onSortEnd} helperContainer={() => document.getElementById('conteiner')}>
                            {campaign.fotos.map((item, index) => (
                                <div key={item.id} className="col-6 col-md-4">
                                    <div className="box-image d-flex justify-content-center align-items-center mt-3">
                                        {(state.isDeleted === item.id) ?
                                            <CircularProgress size="30" color="secondary" />
                                            :
                                            <>
                                                <span id={item.id} onClick={handleConfirm} className="img-action d-flex justify-content-center align-items-center">
                                                    <div className="app-icon d-flex">
                                                        <FaTrash color="#fff" size="1.2em" />
                                                    </div>
                                                </span>
                                                <SortableItem
                                                    key={'item-' + item.id}
                                                    index={index}
                                                    value={item}
                                                />
                                                {(Boolean(state.confirmEl)) &&
                                                    <Confirm
                                                        open={(item.id === parseInt(state.confirmEl.id))}
                                                        onConfirm={() => _deletePhoto(item.id)}
                                                        onClose={() => setState({
                                                            ...state,
                                                            confirmEl: null
                                                        })}
                                                    />
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            ))}

                            <div className="col-6 col-md-4">
                                <div className="box-image box-upload d-flex justify-content-center align-items-center mt-3 mb-3">
                                    <input id="fileIput" onChange={handleUpload} type="file" multiple className="file-input" />
                                    <label htmlFor="fileIput">
                                        {(campaign.upload_photo) ? <CircularProgress /> :
                                            <p className="box-text">
                                                <span className="text-plus">+</span>
                                                <span>Enviar fotos</span>
                                            </p>
                                        }

                                    </label>
                                </div>
                            </div>

                        </SortableList>
                    </div>
                </>
            }
        </div>
        </>
    )
}